import { PenNib, PaperPlaneTilt } from "@phosphor-icons/react";
import { useDocuSign } from "./docusign/useDocuSign";
import DocuSignTermsEditor from "./docusign/DocuSignTermsEditor";
import DocuSignEnvelopeList from "./docusign/DocuSignEnvelopeList";

export default function DocuSignPanel({ c, initialTerms }) {
  const {
    kind, setKind, email, setEmail, name, setName, mode, setMode,
    sending, previewing, rows, refreshing, showTerms, setShowTerms,
    terms, setT, preview, send, refresh,
  } = useDocuSign(c, initialTerms);

  return (
    <div className="bg-white border border-border p-5" data-testid="docusign-panel">
      <div className="flex items-center gap-2 mb-3">
        <PenNib size={16} className="text-primary" />
        <div className="overline text-muted-foreground">Signature électronique · DocuSign</div>
      </div>

      <div className="grid grid-cols-2 gap-2 mb-2">
        <select data-testid="docusign-kind" value={kind} onChange={(e) => setKind(e.target.value)}
          className="border border-border px-2 py-2 text-sm bg-white">
          <option value="loi">LOI — Lettre d'intention</option>
          <option value="nda">NDA — Confidentialité</option>
        </select>
        <select data-testid="docusign-mode" value={mode} onChange={(e) => setMode(e.target.value)}
          className="border border-border px-2 py-2 text-sm bg-white">
          <option value="email">Par email</option>
          <option value="embedded">Signature intégrée</option>
        </select>
      </div>
      <input data-testid="docusign-signer-name" value={name} onChange={(e) => setName(e.target.value)}
        placeholder="Nom du signataire" className="w-full border border-border px-2 py-2 text-sm mb-2" />
      <input data-testid="docusign-signer-email" value={email} onChange={(e) => setEmail(e.target.value)}
        placeholder="Email du signataire" className="w-full border border-border px-2 py-2 text-sm mb-2" />

      <DocuSignTermsEditor kind={kind} terms={terms} setT={setT} showTerms={showTerms}
        setShowTerms={setShowTerms} preview={preview} previewing={previewing} />

      <button data-testid="docusign-send-btn" onClick={send} disabled={sending}
        className="w-full flex items-center justify-center gap-1.5 px-3 py-2 text-sm font-semibold bg-primary text-white hover:opacity-90 disabled:opacity-50">
        <PaperPlaneTilt size={15} /> {sending ? "Envoi…" : "Envoyer pour signature"}
      </button>

      <DocuSignEnvelopeList rows={rows} refreshing={refreshing} refresh={refresh} />
      <p className="text-[11px] text-muted-foreground mt-2">Personnalisez les conditions, prévisualisez le PDF, puis envoyez en signature via DocuSign.</p>
    </div>
  );
}
